import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

export function Gallery() {
  return (
    <div style={{ backgroundColor: '#f5f5f5', minHeight: '100vh', padding: '50px 0' }}>
      <Container>
        <Row className="gallery-row">
          <Col md={6} sm={6} xs={12} className="gallery-column">
            <img src="./img/IMG-20240220-WA0004.jpg" alt="Image 1" className="gallery-image" />
          </Col>
          <Col md={6} sm={6} xs={12} className="gallery-column">
            <img src="./img/IMG-20240220-WA0005.jpg" alt="Image 2" className="gallery-image" />
          </Col>
          <Col md={6} sm={6} xs={12} className="gallery-column">
            <img src="./img/IMG-20240311-WA0004.jpg" alt="Image 3" className="gallery-image" />
          </Col>
          <Col md={6} sm={6} xs={12} className="gallery-column">
            <img src="./img/_DSC5313.jpg" alt="Image 4" className="gallery-image" />
          </Col>
        </Row>
      </Container>
    </div>
  );
}
